var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wrapper d-flex"},[(_vm.includeSidebar)?_c('simbar-sidebar',{attrs:{"items":_vm.sidebarItems,"footer-items":_vm.sidebarFooterItems}}):_vm._e(),_c('main',{class:{
            'wrapper-content': true,
            'include-sidebar': _vm.includeSidebar,
            'bg-light': true
        }},[_vm._t("default"),_c('div',{staticClass:"px-4 mt-4"},[_c('b-alert',{attrs:{"variant":"warning","show":false}},[_c('strong',[_vm._v("AVISO")]),_vm._v(" - Página em construção. ")])],1)],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }